import { Typography } from '@mui/joy';
import type { ReactElement, ReactNode } from 'react';

const StepDescription = ({ children }: { children: ReactNode }): ReactElement => {
  return <Typography level="body-md">{children}</Typography>;
};

export default StepDescription;
